import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["show", "chevron"];
  static values = { active: { type: Boolean, default: false } };

  connect() {
    document.addEventListener("click", this.handleOutsideClick.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick.bind(this));
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target) && this.showTarget.classList.contains("show")) {
      this.showTarget.classList.remove("show");
      this.rotate();
    }
  }

  toggleAndRotate() {
    this.showTarget.classList.toggle("show");

    this.rotate();
  }

  rotate() {
    this.active = !this.active;
    if (this.active) {
      this.chevronTarget.classList.add("rotate-180");
    } else {
      this.chevronTarget.classList.remove("rotate-180");
    }
  }
}
